import { Button } from "@shopify/polaris";
import React, { useCallback, useState, useEffect } from "react";

function CopyButton({
  values,
  handleChange,
  item,
  defaultText = "Copy",
  copiedText = "Copied!",
  disableByFieldState = true,
  trackProgressOnCopy = true,
}) {
  const [copied, setCopied] = useState(false);
  const isDisabled = disableByFieldState && values?.[item]?.disable;

  const copyToClipboard = useCallback(
    async (value, field) => {
      if (!value) return;
      try {
        await navigator.clipboard.writeText(value);
      } catch {
        const el = document.createElement("textarea");
        el.value = value;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
      setCopied(true);
      if (trackProgressOnCopy && !isDisabled) {
        handleChange(field);
      }
    },
    [handleChange, isDisabled, trackProgressOnCopy]
  );

  useEffect(() => {
    if (!copied) {
      return undefined;
    }
    const timer = setTimeout(() => {
      setCopied(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [copied]);

  return (
    <Button
      primary
      disabled={isDisabled}
      accessibilityLabel={copied ? copiedText : defaultText}
      onClick={() => copyToClipboard(values?.[item]?.value, item)}
    >
      {copied ? copiedText : defaultText}
    </Button>
  );
}

export default CopyButton;
